import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-othercarrier',
  templateUrl: './othercarrier.component.html',
  styleUrls: ['./othercarrier.component.scss'],
})
export class OthercarrierComponent implements OnInit {

  tdata:any;
  date:any;
  total:any;
  lc:any;
  opt:any={minimumFractionDigits:0, maximumFractionDigits: 0}
  opt1:any={minimumFractionDigits:2, maximumFractionDigits: 2}
  constructor() { }

  ngOnInit() {
    console.log(this.tdata)
    console.log(this.date)
    console.log(this.total)

  }

  get_perc(x:any){

    return ((x.COB_WEIGHT_CHARGEABLE/this.total)*100).toFixed(2);
  }

}
